import {ScrollTrigger} from "gsap/ScrollTrigger";
import {scrollToId, smoothScrollPause, smoothScrollPlay} from "../scroll-smoother";
import gsap from "gsap/gsap-core";
import {breakpointUp} from "../utils/breakpoints";

$(document).ready(function () {

  if ($('.services-block')) {
    $('.js--change-services-category li').on('click', function () {
      $('.js--change-services-category li').removeClass('active-element');
      $('.services-categories-list .swiper-wrapper .c-btn').removeClass('active');
      $(`li[data-services-category="${$(this).data('services-category')}"]`).addClass('active-element');
      $(`.swiper-slide[data-services-category="${$(this).data('services-category')}"] button`).addClass('active');
      // window.scrollTo(0, 0);
    });

    $('.js--services-open-mobile-filter').on('click', function () {
      const modal = $('.js--services-filter-modal')
      modal.addClass('modal-active');
      $('body').addClass('overflow-hidden');
      $('html').addClass('overflow-hidden');
      smoothScrollPause();
    });

    $('.js--services-filter-modal .inner-children').on('click', function (event) {
      event.stopPropagation();
    });


    $('.js--services-filter-modal, .inner-parent, .js--change-services-category li').on('click', function () {
      const modal = $('.js--services-filter-modal')
      modal.removeClass('modal-active');
      $('body').removeClass('overflow-hidden');
      $('html').removeClass('overflow-hidden');

      smoothScrollPlay();
    });

    ScrollTrigger.create({
      trigger: '#smooth-wrapper',
      pin: '.js--services-filter-modal',
      top: 'top top',
      start: "top-=1000vh top",
      scrub: true,
      pinReparent: true,
      pinType: 'fixed',
      pinSpacing: false,
      endTrigger: 'footer',
      end: 'bottom+=30000vh bottom',
    });
  }
  window.initPopupDivider();

});
let st1;
let st2;
window.initStickyBlock = () => {
  const block = document.querySelector('.services-block')

  if (!block) return false

  const triggerElement = block.querySelector('.sticky-block')
  removeScrollTriggers()

  if ($(window).width() > 991) {
    st1 = ScrollTrigger.create({
      trigger: block,
      pin: triggerElement,
      top: 'top top',
      start: $(window).width() >= 1280 ? 'top top' : '-40px top',
      pinType: 'sticky',
      end: 'bottom bottom',
      scrub: false,
    });
  }

  if ($(window).width() < 992) {
    // st2 = ScrollTrigger.create({
    //   trigger: '#smooth-wrapper',
    //   pin: '.js--services-open-mobile-filter',
    //   top: 'top top',
    //   start: "top-=1000vh top",
    //   scrub: true,
    //   pinReparent: true,
    //   pinType: 'fixed',
    //   endTrigger: 'footer',
    //   pinSpacing: false,
    //   end: 'bottom+=30000vh bottom',
    // });

  } else {
    if (st2) {
      st2.kill();
      st2 = null;
    }
  }


  function removeScrollTriggers() {
    if (st1) {
      st1.kill();
      st1 = null;
    }
    if (st2) {
      st2.kill();
      st2 = null;
    }
  }
}

window.animateservicesGrid = () => {
  gsap.fromTo('#services-posts', {y: 15, opacity: 0}, {
    y: 0,
    opacity: 1,
    delay: 0.5,
  });

}

